<template>
    <ion-app mode="ios">
        <ion-router-outlet/>
        <vue-easy-lightbox
            :visible="$store.getters.getLightBox.visible"
            :imgs="$store.getters.getLightBox.images"
            :index="$store.getters.getLightBox.index"
            :max-zoom="1.5"
            :min-zoom="1"
            :move-disabled="true"
            :loop="true"
            @hide="onLightboxHide"
        >
            <template v-slot:toolbar>

            </template>
        </vue-easy-lightbox>
    </ion-app>
</template>

<script>
import { IonApp, IonRouterOutlet, loadingController } from '@ionic/vue';
import { defineComponent } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox'

const LOADER_DURATION = 2000;

export default defineComponent({
    name: 'App',
    components: {
        IonApp,
        IonRouterOutlet,
        VueEasyLightbox
    },
    data() {
        return {
            loadingEl: null,
            // Les present/dismiss sont enchainés sur cette promesse : les lancer en
            // parallèle laisse un overlay orphelin qui bloque tous les clics.
            loaderQueue: Promise.resolve(),
        }
    },
    watch: {
        '$store.getters.getLoader': function (value) {
            this.loaderQueue = this.loaderQueue
                .then(() => value ? this.showLoader() : this.hideLoader())
                .catch(() => {});
        }
    },
    methods: {
        async showLoader() {
            if (this.loadingEl) {
                return;
            }
            const el = await loadingController.create({ duration: LOADER_DURATION });
            this.loadingEl = el;
            el.addEventListener('ionLoadingDidDismiss', () => {
                if (this.loadingEl === el) {
                    this.loadingEl = null;
                }
            });
            await el.present();
        },

        async hideLoader() {
            const el = this.loadingEl;
            if (!el) {
                return;
            }
            this.loadingEl = null;
            await el.dismiss();
        },

        onLightboxHide() {
            this.$store.commit('setLightBox', { visible:false, images: []});
        }
    }
});
</script>
